import { GraphQLClient } from 'graphql-request'
import { getInstance } from '@/auth'

export default {
  async request(query, variables = {}, draft = undefined) {
    let instance = getInstance()
    let token

    try {
      token = await instance.getTokenSilently()
    } catch (err) {}

    const headers = {
      'accept-language': sessionStorage.getItem('lang'),
      'array-strategy': 'diff',
    }

    if (token) headers['authorization'] = `Bearer ${token}`
    if (draft) headers['kvass-draft'] = draft

    return new GraphQLClient(process.env.VUE_APP_API + '/graphql', {
      headers,
    }).request(query, variables)
  },
}
